module.exports = __webpack_public_path__ + "img/map-sm-2x.c3798ade.jpg";